/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Discounts/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Discounts({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/Breakdown/PayerInfo/Discount/Content/Discounts"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let constantData = '-'
let payerDataTotalDiscountsValueData = fromData.useDataFormat({ viewPath,
context: 'payer',
path: 'data.total_discounts',
format: fromFormat.numberMoney,
})
let aggregateData = fromAggregate.join(constantData, payerDataTotalDiscountsValueData)
  return (<React.Fragment
>
<button
  data-testid="Discounts.Horizontal"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../Expandable/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../Expandable/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../Expandable/Content'))}
 style={{'--pb-1-2dXGK4': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Discounts.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 text="Discounts"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 color={dtColorsNeutral600}
 text={flow.has(fromFlow.normalizePath(viewPath, '../Expandable/Content')) ? "-" : flow.has(fromFlow.normalizePath(viewPath, '../Expandable/No')) ? "+" : "+"}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'-'"
 data="payer.data.total_discounts"
 format="/Data/format.js numberMoney"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</button>
{children}
</React.Fragment>)
}